import { render, staticRenderFns } from "./SupervisedPersonList.vue?vue&type=template&id=04093fd9&scoped=true"
import script from "./SupervisedPersonList.vue?vue&type=script&lang=js"
export * from "./SupervisedPersonList.vue?vue&type=script&lang=js"
import style0 from "./SupervisedPersonList.vue?vue&type=style&index=0&id=04093fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04093fd9",
  null
  
)

export default component.exports